<template>
  <div id="about">

    <AboutMobile v-show="!$store.state.isDesktop" ></AboutMobile>

    <AboutDesktop v-show="$store.state.isDesktop" ></AboutDesktop>

  </div>
</template>

<script>
  import AboutMobile from '@/components/mobile/About';
  import AboutDesktop from '@/components/desktop/About';

  export default {

    name: "about",

    components: {
      AboutMobile,
      AboutDesktop,
    },

    mounted() {
      this.$store.commit("setDisplay", {
        showHeader: true,
        showHeaderLeft: true,
        showFooter: true,
        headerTitle: this.$store.state.cogir ? "about.cogir.title" : "about.title",
        headerIcon: this.$store.state.cogir ? "/svg/octo.svg" : "/svg/humaniti.svg"
      });
    }

  }

</script>

<style lang="scss" scoped>

  #about {
    background-color: #f2f3f4;
  }


</style>